module.exports = __webpack_public_path__ + "media/johncenaout.58bd55e5.mp3";